import { zhCN, en } from './zh-CN';

type TranslationKey = string;

const translations: Record<string, any> = {
  'zh-CN': zhCN,
  'en': en,
  'ja': en, // 可以后续补充日文
  'ko': en, // 可以后续补充韩文
  'zh-TW': zhCN, // 繁体中文暂时使用简体
};

/**
 * 翻译函数
 * @param language 语言代码
 * @param key 翻译键（支持点分隔，如 'travelChat.header.title'）
 * @param params 参数对象（用于替换占位符，如 {groupName}）
 */
export function translateChat(
  language: string,
  key: TranslationKey,
  params?: Record<string, any>
): string {
  const lang = translations[language] || translations['zh-CN'];
  const keys = key.split('.');
  
  let value: any = lang;
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) break;
  }
  
  if (typeof value !== 'string') {
    return key; // 返回键本身作为fallback
  }
  
  // 替换参数
  if (params) {
    return value.replace(/\{(\w+)\}/g, (match: string, paramKey: string) => {
      return params[paramKey] !== undefined ? String(params[paramKey]) : match;
    });
  }
  
  return value;
}
